import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const BASENAME = process.env.REACT_APP_BASENAME || "";
        console.log("SocketProvider: Initializing socket with URL:", process.env.REACT_APP_API_URL);
        // Correctly parse the domain and set the path for cPanel/Passenger compatibility
        const rawApiUrl = process.env.REACT_APP_API_URL;
        const urlValue = (rawApiUrl && rawApiUrl !== "undefined") ? rawApiUrl : "https://flowsalonsg.com/api";
        const url = urlValue ? urlValue.replace(`${BASENAME}/api`, '').replace(/\/api$/, '') : '/';
        const newSocket = io(url, {
            path: `${BASENAME}/api/socket.io`
        });

        newSocket.on('connect', () => {
            console.log("SocketProvider: Connected!", newSocket.id);
        });

        newSocket.on('connect_error', (err) => {
            console.error("SocketProvider: Connection Error", err);
        });

        setSocket(newSocket);

        return () => newSocket.close();
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
